import { IconType } from 'react-icons';
import {
  FaChartBar,
  FaLifeRing,
  FaLink,
  FaMicrophone,
  FaRegCommentDots,
  FaRegHandPaper,
} from 'react-icons/fa';

export interface NavItem {
  id: string;
  label: string;
  path: string;
  icon: IconType;
}

export const primaryNavItems: NavItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    path: '/dashboard',
    icon: FaChartBar,
  },
  {
    id: 'aac',
    label: 'AAC',
    path: '/aac',
    icon: FaRegCommentDots,
  },
  {
    id: 'voice',
    label: 'Voz',
    path: '/voz',
    icon: FaMicrophone,
  },
  {
    id: 'gestures',
    label: 'Gestos',
    path: '/gesture-recognition',
    icon: FaRegHandPaper,
  },
  {
    id: 'resources',
    label: 'Recursos',
    path: '/links',
    icon: FaLink,
  },
  {
    id: 'help',
    label: 'Ajuda',
    path: '/help',
    icon: FaLifeRing,
  },
];

const PAGE_TITLES: Record<string, string> = {
  '/voz': 'Voz',
  '/dashboard': 'Dashboard',
  '/aac': 'AAC',
  '/gesture-recognition': 'Gestos',
  '/help': 'Ajuda',
  '/links': 'Recursos',
  '/docs': 'Documentacao',
  '/guides': 'Guias',
  '/login': 'Entrar',
  '/register': 'Criar conta',
  '/signup': 'Criar conta',
  '/profile': 'Perfil',
};

export const getPageTitle = (pathname: string): string => {
  const exactTitle = PAGE_TITLES[pathname];
  if (exactTitle) {
    return exactTitle;
  }

  const nestedTitle = primaryNavItems.find((item) => {
    if (item.path === '/') {
      return false;
    }

    return pathname.startsWith(`${item.path}/`);
  });

  return nestedTitle?.label ?? 'EcoVoz';
};
